import { useState } from 'react';
import dynamic from 'next/dynamic';

import Zoom from '@/assets/icons/zoom.svg';

import type { FunctionComponent } from 'react';
import type { TypeIframeProps } from './types';

const PopUpIframe = dynamic(() => import('./PopUpIframe'), {
  ssr: true,
});
/**
 * Iframe
 */
export const Iframe: FunctionComponent<TypeIframeProps> = ({
  className = '',
  src,
  popUp,
  descPopUp,
  popUpTitle,
  isYoutube,
  ...props
}: TypeIframeProps) => {
  const [open, setOpen] = useState(false);
  const showGallery = () => {
    setOpen(!open);
  };

  return (
    <>
      {popUp && (
        <>
          <PopUpIframe
            title={popUpTitle}
            src={src}
            setState={setOpen}
            state={open}
            desc={descPopUp}
            {...props}
          />
          <div
            className="absolute right-3 top-3 z-10 h-8 w-8 cursor-pointer"
            onClick={showGallery}
          >
            <Zoom />
          </div>
        </>
      )}

      <iframe
        src={src}
        {...(isYoutube && {
          allowFullScreen: true,
          mozallowFullScreen: true,
          msallowFullScreen: true,
          oallowFullScreen: true,
          webkitAllowFullScreen: true,
        })}
        {...props}
        className={`h-full w-full border-none ${className}`}
      />
    </>
  );
};

Iframe.displayName = 'Iframe';
